import * as Sentry from '@sentry/browser'
import axios, { AxiosError, AxiosHeaders } from 'axios'

import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

const abiApiHeaders = () => {
  const pathName = window.location.pathname
  const apiKey = pathName.split('/')[1]
  if (!apiKey) throw new Error(ERROR_CODE.NO_API_KEY)

  return new AxiosHeaders({
    'x-api-key': apiKey,
    'Content-Type': 'application/json'
  })
}

export const actionsRequest = <T extends Action<ACTION_TYPE>>(body: { payload: T['payload']; type: string; version?: string }) =>
  axios.post<T['response']>(`${import.meta.env.VITE_API_URL}/flow`, body, {
    headers: abiApiHeaders()
  })

export const handleRequestError = (err: unknown, action: ACTION_TYPE, payload?: any) => {
  if (axios.isAxiosError(err)) {
    const error = err as AxiosError
    console.error('Axios Error', action, error)

    Sentry.captureException(error, {
      tags: {
        action
      },
      contexts: {
        Additional: {
          action,
          payload: {
            ...payload
          }
        },
        'Axios Error': {
          data: typeof error?.response?.data === 'object' ? { ...error?.response?.data } : error?.response?.data
        },
        Error: {
          ...error
        }
      }
    })

    throw error
  } else {
    Sentry.captureException(err, {
      tags: {
        action
      }
    })

    console.error('Not axios error', action, err)

    const queryString = window.location.search
    window.location.href = `/error${queryString}`
  }
}
